import { memo, FC, Dispatch, SetStateAction, useMemo } from 'react'
import { Fade, Flex, FlexProps, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react'

import { SalaryFilterKeyString } from 'InstitutionalManagement/types'
import { RefreshButton } from 'components'
import { SALARY_INITIAL_FILTER } from 'InstitutionalManagement/constants/pages/salaries'
import { getSalaryFilterFeedbacks } from 'InstitutionalManagement/utils/getSalaryFilterFeedbacks'

type Props = FlexProps & {
  salaryFilter: SalaryFilterKeyString
  setSalaryFilter: Dispatch<SetStateAction<SalaryFilterKeyString>>
}

const SalaryFilterTags: FC<Props> = ({ salaryFilter, setSalaryFilter, ...flexProps }) => {
  const filtersWithValue = useMemo(() => {
    return Object.entries(salaryFilter).filter(([key]) => {
      return salaryFilter[key] !== SALARY_INITIAL_FILTER[key]
    })
  }, [salaryFilter])

  function resetFilterByKey(key: string) {
    setSalaryFilter({ ...salaryFilter, [key]: SALARY_INITIAL_FILTER[key] })
  }

  function resetAllFilters() {
    setSalaryFilter(SALARY_INITIAL_FILTER)
  }

  function setFilterFeedbackInTagByKey(key: string, value: string) {
    const filterTagFeedbacks: SalaryFilterKeyString = getSalaryFilterFeedbacks(value)
    return filterTagFeedbacks[key]
  }

  if (filtersWithValue.length === 0) return null

  return (
    <Fade in>
      <Flex align="center" flexWrap="wrap" gap={2} {...flexProps}>
        {filtersWithValue.map(([key, value]) => (
          <Tag key={key} variant="filter-tags">
            <TagLabel>{setFilterFeedbackInTagByKey(key, value)}</TagLabel>
            <TagCloseButton onClick={() => resetFilterByKey(key)} />
          </Tag>
        ))}

        <RefreshButton onClick={resetAllFilters}>Limpar filtros</RefreshButton>
      </Flex>
    </Fade>
  )
}

export default memo(SalaryFilterTags)
